
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FooterPagesService } from 'app/homepage-configuration/footer-config/footer-pages/footer-pages.service';
import { FooterBarLinkResource } from 'app/models/FooterBarLinkResource';
import { NotificationsService } from 'angular2-notifications';
import { UtilsService } from '../../../services/utils.service'; 

@Component({
  selector: 'vbn-footer-pages',
  templateUrl: './footer-pages.component.html',
  styleUrls: ['./footer-pages.component.scss'],
  providers: [FooterPagesService],
})
export class FooterPagesComponent implements OnInit {

  columnTitleLang: string = "ro"
  saveErrors: boolean = false;
  showError: boolean;
  saveErrors2: boolean = false;
  pageParam: any;
  errorMessage: string;
  footerBarLinkResource: FooterBarLinkResource;
  showConfirmation;
  user = localStorage.getItem("_user");

  constructor(
    private fb: FormBuilder, 
    private translate: TranslateService, 
    private router: Router, 
    private _router: Router, 
    private footerPagesService: FooterPagesService, 
    private _notificationService: NotificationsService, 
    private activatedRoute: ActivatedRoute, 
    private utilsService: UtilsService) {
    this.showError = false;
    this.footerBarLinkResource = new FooterBarLinkResource();
    this.footerBarLinkResource.configurable = true;
    this.footerBarLinkResource.openUrlBlank = false; 
  }

  qullFormat: any = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': '' }, { 'align': 'center' }],
      ['clean'],
      ['link', 'image']
    ]
  }
  public options: Object = {

    language: 'ro',

    charCounterCount: true,
    // Set the image upload parameter.
    imageUploadParam: 'image_param',

    // Set the image upload URL.
    imageUploadURL: '/admin/texteditor/uploadFile',

    // Additional upload params.
    imageUploadParams: { id: 'my_editor' },

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png', 'bmp', 'gif'],

  };


  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['json'] != undefined) {
        this.pageParam = JSON.parse(atob(params['json']));
        console.log("--------------------------------------", this.pageParam);
        this.getPageById(this.pageParam.rid);
      }
    });
  }

  addPages = this.fb.group({
    titleRoColumn: ['', [Validators.required, Validators.maxLength(50), this.utilsService.NoWhitespaceValidator()]],
    titleEnColumn: [''],
    titleFrColumn: [''],
    titleDeColumn: [''],
  })

  urlValid = this.fb.group({
    url:['',[Validators.required, this.utilsService.NoWhitespaceValidator()]],
  })

  cancel() {
    this.router.navigateByUrl('/footer-page-list');
  }

  savePage() {
    this.saveErrors = true
    if (!this.addPages.valid || !this.footerBarLinkResource.configurable && !this.urlValid.valid) {
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      if(!this.footerBarLinkResource.configurable){
        this.saveErrors2 = true;
        if(!this.urlValid.valid){
          observableForkJoin(
            this.translate.get('Error'),
            this.translate.get('URL field must be completed!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
        }
      }
      return
    }
    this.footerBarLinkResource.titleRo = this.utilsService.WhiteSpacesRemover(this.footerBarLinkResource.titleRo);
    this.footerBarLinkResource.titleFr = this.utilsService.WhiteSpacesRemover(this.footerBarLinkResource.titleFr);
    this.footerBarLinkResource.titleDe = this.utilsService.WhiteSpacesRemover(this.footerBarLinkResource.titleDe);
    this.footerBarLinkResource.titleEn = this.utilsService.WhiteSpacesRemover(this.footerBarLinkResource.titleEn);
    if(!this.footerBarLinkResource.configurable){
      this.footerBarLinkResource.url = this.utilsService.WhiteSpacesRemover(this.footerBarLinkResource.url);
    }   
    this.footerBarLinkResource.userEmail = this.user
    this.footerPagesService.saveFooterPage(`/admin/footer/barLink/edit`, this.footerBarLinkResource)
      .subscribe(
        body => {
          if (body.errorCode == 9088) {
            observableForkJoin(
              this.translate.get('Error'),
              this.translate.get('You can add only 5 active pages!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
            return
          }
          if (body.errorCode == 9097) {
            this.saveErrors2 = true;
            if(!this.urlValid.valid){
              observableForkJoin(
                this.translate.get('Error'),  
                this.translate.get('URL field must be completed!')
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
              return
            }            
          }
          // if(this.footerBarLinkResource.isConfigurable == true) {}
          this.footerBarLinkResource = body
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Page saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.router.navigate(['/footer-page-list/']);
        },
        error => console.error(error))
  }

  getPageById(rid: number) {
    this.footerPagesService.getPageByIdService('/admin/footer/barLink/getOne/' + rid + "?email=" + this.user)
      .subscribe(
        response => {
          console.log("-------------", response)
          this.footerBarLinkResource = response;
        },
        error => this.errorMessage = <any>error);
  }
}
